import { getEnv } from "./env";

export const getNetworkName = (value) => {
	const networks = getEnv().networkProviders;

	return networks.find((network) => value === network.value).name;
};

export const getNetworkValue = (name) => {
	const networks = getEnv().networkProviders;

	return networks.find((network) => name === network.name).value;
};
